import React, { useState } from "react";
import { useBalance } from "../contexts/BalanceContext";
import { useTheme } from "../contexts/ThemeContext";
import { Wallet, Plus, AlertTriangle } from "lucide-react";
import AddFundsModal from "./AddFundsModal";

const BalanceWidget = () => {
  const { currentBalance, isLowBalance, loading } = useBalance();
  const { isDark } = useTheme();
  const [showFundsModal, setShowFundsModal] = useState(false);

  if (loading) return null;

  const low = isLowBalance();

  return (
    <>
      <button
        onClick={() => setShowFundsModal(true)}
        className={`flex items-center gap-1.5 px-3 py-1.5 rounded-xl text-xs font-semibold transition-all group ${
          low
            ? 'bg-red-500/10 text-red-400 border border-red-500/20 hover:bg-red-500/20'
            : isDark
              ? 'bg-white/5 text-white/70 border border-white/10 hover:bg-white/10 hover:text-white'
              : 'bg-gray-50 text-gray-600 border border-gray-200 hover:bg-gray-100 hover:text-gray-900'
        }`}
        data-testid="balance-widget"
      >
        {low ? (
          <AlertTriangle className="w-3.5 h-3.5 text-red-400" />
        ) : (
          <Wallet className="w-3.5 h-3.5" />
        )}
        <span>${currentBalance.toFixed(2)}</span>
        <Plus className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity" />
      </button>

      <AddFundsModal open={showFundsModal} onClose={() => setShowFundsModal(false)} />
    </>
  );
};

export default BalanceWidget;
